import isExperienceEditor from "@utils/is-experience-editor";

var VCA = VCA || {};


VCA.mobilePeekSlider = (function ($) {

    var ui = {};
    var MEDIA_QUERY = '(max-width: 767px)';
    var mql = window.matchMedia(MEDIA_QUERY);
    var started = false;

    function init() {
        cacheUI();
        mobilePeekSlider();
        mobilePeekSliderKyp();
    }

    function cacheUI() {
        ui.$body = $('body');
        ui.$statsSlider = $('.js-mobile-peek');
        ui.$statsSliderKyp = $('.js-mobile-peek-kyp')
    }

    function mobilePeekSlider() { 
        if (mql.matches) {
            var statsSlider = ui.$statsSlider.each(function (index, element) {
                $(this).addClass('js-mobile-peek' + index);
                var item_length = $('.js-mobile-peek' + index + ' > div').length;
                if (item_length > 1 && !isExperienceEditor) {
                    $('.js-mobile-peek' + index).slick({
                        autoplay: false,
                        infinite: true,
                        arrows: false,
                        dots: false,
                        initialSlide: 0,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: true,
                        focusOnChange: true,
                        accessibility: true,
                        mobileFirst: true,
                        responsive: [{
                            breakpoint: 767,
                            settings: "unslick"
                        }]
                    });
                }
            });
        }
    }

    function mobilePeekSliderKyp() { 
        if (mql.matches) {
            var statsSliderKyp = ui.$statsSliderKyp.each(function (index, element) {
                $(this).addClass('js-mobile-peek-kyp' + index);
                var item_length = $('.js-mobile-peek-kyp' + index + ' > div').length;
                if (item_length > 1 && !isExperienceEditor) {
                    $('.js-mobile-peek-kyp' + index).slick({
                        autoplay: false,
                        infinite: true,
                        arrows: false,
                        dots: false,
                        initialSlide: 0,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: true,
                        variableWidth: true,
                        focusOnChange: true,
                        accessibility: true,
                        mobileFirst: true,
                        responsive: [{
                            breakpoint: 767,
                            settings: "unslick"
                        }]
                    });
                }
            });
        }
    }


    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.mobilePeekSlider.init();
});